export interface QuotationFile {
    filename: string;
    b64File: string;
}

export function quotationFileFactory(filename: string, b64File: string) {
    return {
        filename: filename,
        b64File: b64File
    } as QuotationFile;
}
